module.exports = __webpack_public_path__ + "img/modal-bg.e3dd7437.png";